import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cw-widget" }
const _hoisted_2 = {
  key: 0,
  style: {"margin":"5px"},
  "data-v-06fb36cc": "",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "logo"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 0H9H11C13.2091 0 15 1.79086 15 4V6V24H13C10.7909 24 9 22.2091 9 20V6H5C2.79086 6 1 4.20914 1 2V0ZM19 0H17V6H23V4C23 1.79086 21.2091 0 19 0Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "cw-title"
}
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-volume-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-volume-x"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("line", {
  x1: "23",
  y1: "9",
  x2: "17",
  y2: "15"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("line", {
  x1: "17",
  y1: "9",
  x2: "23",
  y2: "15"
}, null, -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "cw-header-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "svg_1",
    opacity: "0.6",
    d: "m4.20787,12.70787l8.5,0l0,-8.5m-10,-1.5l10,10",
    "stroke-width": "2",
    "stroke-linejoin": "round",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "cw-messaging-holder"
}
const _hoisted_19 = { class: "cw-uploads" }
const _hoisted_20 = { class: "cw-typingindicator-holder" }
const _hoisted_21 = { class: "cw-message-holder" }
const _hoisted_22 = { class: "cw-actions-holder" }
const _hoisted_23 = {
  key: 0,
  for: "tickwidget-fileUpload"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "cw-general-button" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "feather feather-paperclip"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  "data-v-344e9f68": "",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 12.6668V3.3335" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.33325 8.00016L7.99992 3.3335L12.6666 8.00016" })
], -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lobby = _resolveComponent("Lobby")!
  const _component_Message = _resolveComponent("Message")!
  const _component_TickFileUploadProgress = _resolveComponent("TickFileUploadProgress")!
  const _component_TypingIndicator = _resolveComponent("TypingIndicator")!
  const _component_TickTextarea = _resolveComponent("TickTextarea")!
  const _component_FileDropZone = _resolveComponent("FileDropZone")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.showWidgetButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.toggleWidget && this.toggleWidget(...args))),
          class: _normalizeClass(["cw-widget-button-holder", [this.openerTypeName, { 'slide-in': !this.showWidget, 'showFullScreen': this.showFullScreen, 'slide-out': this.showWidget, 'use-custom-padding': this.useCustomOpenerPadding }]]),
          style: _normalizeStyle(this.cssVars)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["cw-icon", { 'has-bg': this.openerHasBackgroundImage }])
          }, [
            (this.showTickOpenerLogo)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true)
          ], 2),
          (this.openerTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(this.openerTitle), 1))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true),
    (this.showWidget)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["cw-widget-holder", { 'showFullScreen': this.showFullScreen, 'slide-in': this.showWidget, 'slide-out': !this.showWidget, 'useWidth': this.useWidth, 'forceShowWidget': this.forceShowWidget }]),
          style: _normalizeStyle(this.cssVars)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["cw-header-holder", { 'use-custom-padding': this.useCustomHeaderPadding }])
          }, [
            _withDirectives(_createElementVNode("button", {
              class: _normalizeClass(["cw-header-toggle-notifications", { 'on': this.notifyIncomingMessages }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.toggleNotifications && this.toggleNotifications(...args)))
            }, [
              (this.notifyIncomingMessages)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
                : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_14))
            ], 2), [
              [_vShow, !this.showLobby]
            ]),
            _createElementVNode("span", _hoisted_15, _toDisplayString(this.generalTitle), 1),
            _createElementVNode("button", {
              class: "cw-header-toggle-widget",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.toggleWidget && this.toggleWidget(...args)))
            }, _hoisted_17)
          ], 2),
          _createVNode(_component_FileDropZone, {
            onDropped: this.addFiles,
            clickToSelect: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["cw-widget-content", { 'use-custom-padding': this.useCustomPadding }])
              }, [
                (this.showLobby)
                  ? (_openBlock(), _createBlock(_component_Lobby, {
                      key: 0,
                      onOnAction: this.onLobbyAction,
                      settings: this.widgetSettings
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    }, 8, ["onOnAction", "settings"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.messages, (message, index) => {
                        return (_openBlock(), _createBlock(_component_Message, {
                          showAvatar: this.showAvatar,
                          useCustomActionPadding: this.useCustomActionPadding,
                          useCustomInboundPadding: this.useCustomInboundMessagePadding,
                          useCustomOutboundPadding: this.useCustomOutboundMessagePadding,
                          message: message,
                          positionAllMessagesLeft: this.positionAllMessagesLeft,
                          sameSenderAsBefore: this.isSameSenderAsBefore(message, index),
                          key: message.messageId
                        }, null, 8, ["showAvatar", "useCustomActionPadding", "useCustomInboundPadding", "useCustomOutboundPadding", "message", "positionAllMessagesLeft", "sameSenderAsBefore"]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.uploadingFiles, (file) => {
                          return (_openBlock(), _createBlock(_component_TickFileUploadProgress, {
                            file: file,
                            key: file.id
                          }, null, 8, ["file"]))
                        }), 128))
                      ])
                    ])),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_TypingIndicator, {
                    users: this.typingUsers,
                    communicators: this.typingCommunicators
                  }, null, 8, ["users", "communicators"])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["cw-communication-holder", { 'use-custom-padding': this.useCustomMessageBoxPadding }])
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_TickTextarea, {
                      class: "cw-message-draft-text",
                      onEnter: this.onHitEnter,
                      modelValue: this.draft.message,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.draft.message) = $event))
                    }, null, 8, ["onEnter", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (this.fileUploadsAllowed)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_23, _hoisted_25))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "cw-general-button",
                      onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (this.send && this.send(...args)), ["stop","prevent"]))
                    }, _hoisted_27, 32)
                  ])
                ], 2)
              ], 2)
            ]),
            _: 3
          }, 8, ["onDropped"])
        ], 6))
      : _createCommentVNode("", true)
  ]))
}